import { Button, Box, Typography } from "@mui/material";

function EnterKiosk({ onEnter }) {
  const enterFullscreen = async () => {
    if (document.documentElement.requestFullscreen) {
      await document.documentElement.requestFullscreen();
    }
    onEnter();
  };

  return (
    <Box
      height="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Typography variant="h5" gutterBottom>
        Touch to Start
      </Typography>
      <Button variant="contained" size="large" onClick={enterFullscreen}>
        Enter Kiosk Mode
      </Button>
    </Box>
  );
}

export default EnterKiosk;
